export default __webpack_public_path__ + "static/media/login-page.30e4f2e6.svg";